module.exports = __webpack_public_path__ + "img/moren.639be7dd.png";